import { OVERLAY_ATTRIBUTE, OVERLAY_OPACITY_ATTRIBUTE } from '../../constants/display-options';
import {
  BACKGROUND_IMAGE_ATTRIBUTE,
  BACKGROUND_HIDDEN_ATTRIBUTE,
  BACKGROUND_PLACEHOLDER_ATTRIBUTE,
} from '../../constants/block-background-attributes';
import isOverlayTouchedVerifier from '../../verifiers/is-overlay-touched';
import copyDisplayOptionByAttribute from '../copy-display-option-by-attribute';

const copyOverlayAttributes = (displayOptions, destinationBlockNode) => {
  [OVERLAY_OPACITY_ATTRIBUTE, OVERLAY_ATTRIBUTE].forEach((attribute) =>
    copyDisplayOptionByAttribute({
      displayOptions,
      destinationBlockNode,
      attribute,
    })
  );
};

const handleChangeOverlay = ({ backgroundOption, displayOptions, destinationBlockNode }) => {
  const isOverlayTouched = isOverlayTouchedVerifier(displayOptions);

  if (!backgroundOption && !isOverlayTouched) {
    copyOverlayAttributes(displayOptions, destinationBlockNode);

    return;
  }

  if (
    backgroundOption &&
    backgroundOption.blockNode.hasAttribute(BACKGROUND_IMAGE_ATTRIBUTE) &&
    !backgroundOption.blockNode.hasAttribute(BACKGROUND_HIDDEN_ATTRIBUTE) &&
    !backgroundOption.blockNode.hasAttribute(BACKGROUND_PLACEHOLDER_ATTRIBUTE)
  ) {
    copyOverlayAttributes(displayOptions, destinationBlockNode);
  }
};

export default handleChangeOverlay;
